import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { SolicitareRankService } from '../solicitare-rank.service';

@Component({
  selector: 'app-edit-solicitare-rank',
  templateUrl: './edit-solicitare-rank.component.html',
  styleUrls: ['./edit-solicitare-rank.component.scss']
})
export class EditSolicitareRankComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;

  editorConfig!: AngularEditorConfig;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name, [Validators.required]),
    slug: new FormControl(this.data.slug, [Validators.required]),
    color: new FormControl(this.data.color, [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditSolicitareRankComponent>,
    private solicitareRankService: SolicitareRankService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }
  ngOnInit(): void {
    this.editorConfig = initializeEditor();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.solicitareRankService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedSablonData = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      color: this.form.get('color')?.value,
      id: this.data.id,
    };

    this.solicitareRankService
      .updateRankSolicitare(updatedSablonData)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
